// extracted by mini-css-extract-plugin
module.exports = {"root":"other-hazardous-waste-page_root__E5Fxk"};